import { render, staticRenderFns } from "./marksheet.vue?vue&type=template&id=226b9eac&"
import script from "./marksheet.vue?vue&type=script&lang=js&"
export * from "./marksheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports